<template>
  <div class="login">
    <div class="login_container">
      <img src="../../assets/image/logo.svg" alt />
      <span>喜鹊数字化平台</span>
      <el-input
        v-model="phone"
        :class="{error:(submited&&phone.length!=11)||(smsGeted&&phone.length!=11)}"
        placeholder="手机号码"
        size="large"
        style="margin-bottom:40px"
      ></el-input>
      <el-input
        :class="{error:submited&&code.length==0}"
        v-model="code"
        placeholder="验证码"
        size="large"
      >
        <el-button slot="append" @click="getSmsCode">{{smsCountdown?countdown+"s":"验证码"}}</el-button>
      </el-input>
      <el-button type="primary" size="large" style="width:100%;margin-top:50px" @click="login">登录</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      phone: "",
      code: "",
      smsGeted: false,
      submited: false,
      countdown: 60,
      smsCountdown: false,
      timer: null
    };
  },
  methods: {
    getSmsCode: function() {
      this.smsGeted = true;
      if (this.phone.length != 11) {
        this.$message({
          message: "请输入11位手机号",
          type: "error"
        });
        return;
      }
      if (this.smsCountdown) {
        return;
      }
      this.$api
        .get("/xsss/v1/smscode", {
          phone: this.phone
        })
        .then(() => {
          this.smsCountdown = true;
          this.timer = setInterval(() => {
            this.countdown--;
            if (this.countdown < 1) {
              clearInterval(this.timer);
              this.smsCountdown = false;
            }
          }, 1000);
          this.$message({
            message: "验证码发送成功",
            type: "success"
          });
        });
    },
    login: function() {
      this.submited = true;
      if (this.phone.length != 11) {
        this.$message({
          message: "请输入11位手机号",
          type: "error"
        });
        return;
      }
      if (this.code.length != 4) {
        this.$message({
          message: "请输入4位验证码",
          type: "error"
        });
        return;
      }
      this.$api
        .post("/xsss/v1/adminlogin", {
          phone: this.phone,
          code: this.code
        })
        .then(res => {
          localStorage.setItem("admin.access_token", res.data.access_token);
          localStorage.setItem("admin.refresh_token", res.data.refresh_token);
          this.$router.push("/staff");
        });
    }
  }
};
</script>

<style scoped>
@import url("./index.css");
</style>